// Centralized return value types for all selector components
// This ensures consistency across all selectors and reduces code duplication

export const SELECTOR_RETURN_TYPES = {
  ID: 'id',
  NAME: 'name'
};

// Legacy exports for backward compatibility
// These will be removed in a future version
export const RETURN_VALUE_TYPES = SELECTOR_RETURN_TYPES;

// Specific exports for each selector type
// This allows for future customization if needed
export const POSITION_RETURN_TYPES = SELECTOR_RETURN_TYPES;
export const CLUSTER_RETURN_TYPES = SELECTOR_RETURN_TYPES;
export const GRADE_RETURN_TYPES = SELECTOR_RETURN_TYPES;
export const COMPANY_RETURN_TYPES = SELECTOR_RETURN_TYPES;
export const CONTRACT_TYPE_RETURN_TYPES = SELECTOR_RETURN_TYPES;
export const CLIENT_RETURN_TYPES = SELECTOR_RETURN_TYPES;
export const COUNTRY_RETURN_TYPES = SELECTOR_RETURN_TYPES;
export const EMPLOYEE_RETURN_TYPES = {
  ...SELECTOR_RETURN_TYPES,
  EMAIL: 'email',
  FULL_NAME: 'fullName',
  OBJECT: 'object'
};
export const BUSINESS_AREA_RETURN_TYPES = SELECTOR_RETURN_TYPES;
export const BUSINESS_UNIT_RETURN_TYPES = SELECTOR_RETURN_TYPES;
// Org unit types additionally expose CODE ('delivery', 'human_resources', …):
// environment-stable, unlike ids — used by filters that need a fixed default
// (ADR-093: the Assignment Completion report defaults to Delivery by code)
export const ORG_UNIT_TYPE_RETURN_TYPES = {
  ...SELECTOR_RETURN_TYPES,
  CODE: 'code'
};
// ADR-119: Organizational Structure Types (Cluster classification)
// expose CODE for the same reason.
export const ORG_STRUCTURE_TYPE_RETURN_TYPES = {
  ...SELECTOR_RETURN_TYPES,
  CODE: 'code'
};
export const ENGAGEMENT_TYPE_RETURN_TYPES = SELECTOR_RETURN_TYPES;
export const PROJECT_RETURN_TYPES = SELECTOR_RETURN_TYPES;
export const PROJECT_PURPOSE_RETURN_TYPES = SELECTOR_RETURN_TYPES;
export const BILLING_TYPE_RETURN_TYPES = SELECTOR_RETURN_TYPES;
export const CLIENT_PARTY_TYPE_RETURN_TYPES = SELECTOR_RETURN_TYPES;
export const PROJECT_SCOPE_TYPE_RETURN_TYPES = SELECTOR_RETURN_TYPES;
export const PROJECT_STATUS_RETURN_TYPES = SELECTOR_RETURN_TYPES;